<div class="col-12 d-flex justify-content-center flex-column mx-auto my-1">
	<label for="">{{LabelName | translate}}</label>
	<kendo-upload #photoUploader [disabled]="UploadBtnDisabled" [saveUrl]="SaveUrl" [withCredentials]="false"
		[autoUpload]="AutoUpload" [restrictions]="UploadRestrictions" (upload)="uploadPhoto($event)"
		(select)="selectPhoto($event)" (complete)="complete()">
		<ng-template kendoUploadFileTemplate>
			<div class="file-item" *ngIf="previewSrc && !invalidImage">
				<img class="img-preview" [src]="previewSrc" />
			</div>
		</ng-template>
	</kendo-upload>

	<button [disabled]="ClearBtnDisabled"
		class="btn k-button k-button-md k-rounded-md k-button-solid k-button-solid-base k-clear-selected" kendoButton
		role="button" (click)="clearPhoto()">{{'Clear' | translate}}
	</button>

	<div *ngIf="MainFormGroup">
		<div *ngIf="BindingProperty?.getRawValue() && !(previewSrc && !invalidImage) " class="file-item">
			<img class="img-preview"
				[src]="sanitizer.bypassSecurityTrustResourceUrl(src + BindingProperty?.getRawValue())" />
		</div>
	</div>
</div>